import { MeetingTypeResourceTypeMappings } from '@aa/nest/resource';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { formatDateTime } from '@aa/ts/common';
import { DataTableColumnConfig } from '../../components/data-table/data-table.component';
import {
  BaseResourceListViewComponent,
  baseResourceListViewImports,
} from '../base-resource-list-view/base-resource-list-view.component';
import { MeetingTypeFormModalComponent } from '../../forms/meeting-type-form-modal/meeting-type-form-modal.component';
import { meetingTypeActions } from '../../state/meeting-type/meeting-type.actions';
import { selectMeetingTypeState } from '../../state/meeting-type/meeting-type.reducer';

@Component({
  selector: 'aa-meeting-types-list-view',
  standalone: true,
  imports: [...baseResourceListViewImports],
  templateUrl:
    '../../../../../core/src/lib/views/base-resource-list-view/base-resource-list-view.component.html',
  styleUrl:
    '../../../../../core/src/lib/views/base-resource-list-view/base-resource-list-view.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MeetingTypesListViewComponent extends BaseResourceListViewComponent<MeetingTypeResourceTypeMappings> {
  title = 'Meeting Types';
  columns = [
    {
      key: 'id',
      label: 'ID',
      minWidth: '3rem',
    },
    {
      key: 'label',
      label: 'Label',
    },
    {
      key: 'description',
      label: 'Description',
    },
    {
      key: 'price',
      label: 'Price',
    },
    {
      key: 'durationInMinutes',
      label: 'Duration in Minute',
    },
    {
      key: 'createdAt',
      label: 'Created At',
      accessor: (row) => formatDateTime(row.createdAt),
      minWidth: '15rem',
    },
    {
      key: 'updatedAt',
      label: 'Updated At',
      accessor: (row) => formatDateTime(row.updatedAt),
      minWidth: '15rem',
    },
  ] as DataTableColumnConfig<
    MeetingTypeResourceTypeMappings['resourceWithRelationsT']
  >[];

  stateSelector = selectMeetingTypeState;
  loadAction = meetingTypeActions.loadItems({
    query: {
      pageSize: this.initialPageSize,
    },
  });
  actions = meetingTypeActions;

  createFormModalTypeGetter = () => MeetingTypeFormModalComponent;
  updateFormModalTypeGetter = () => MeetingTypeFormModalComponent;
}
